import React from "react";
import { useLocation } from "react-router-dom";

class NavigationErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Page navigation failed", error, info);
  }

  componentDidUpdate(previousProps) {
    if (this.state.error && previousProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <main style={{ minHeight: "100vh", background: "#161616", color: "#fff", display: "grid", placeItems: "center", padding: 24 }}>
        <section style={{ width: "100%", maxWidth: 520, background: "#222", border: "1px solid #3b3b3b", padding: 28 }}>
          <h1 style={{ marginTop: 0, fontSize: 24 }}>Không thể mở trang này</h1>
          <p style={{ color: "#cbd5e1", lineHeight: 1.6 }}>
            Phiên bản trang trong trình duyệt có thể đã cũ. Hãy tải lại để tiếp tục.
          </p>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
            <button type="button" onClick={() => window.location.reload()} style={{ cursor: "pointer", border: 0, background: "#d22123", color: "#fff", padding: "10px 18px", fontWeight: 600 }}>
              Tải lại trang
            </button>
            <button type="button" onClick={() => window.location.assign("/")} style={{ cursor: "pointer", border: "1px solid #555", background: "transparent", color: "#fff", padding: "10px 18px" }}>
              Về trang chủ
            </button>
          </div>
        </section>
      </main>
    );
  }
}

function NavigationErrorGuard({ children }) {
  const location = useLocation();
  return <NavigationErrorBoundary resetKey={`${location.pathname}${location.search}`}>{children}</NavigationErrorBoundary>;
}

export default NavigationErrorGuard;
